// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useField } from 'formik';
import { withClassName } from '../../hooks.js';
import { useIdOrGenerated } from '../../hooks/useIdOrGenerated.js';
import { Checkbox } from '../checkbox/index.js';
export function CheckboxField(_a) {
    var { name, label, className, required, id: providedId } = _a, rest = __rest(_a, ["name", "label", "className", "required", "id"]);
    const [props, _, tools] = useField({ name, type: 'checkbox' });
    const id = useIdOrGenerated(providedId);
    return (_jsxs(FieldRoot, { className: className, children: [_jsx(Checkbox, Object.assign({}, props, { checked: props.checked, onCheckedChange: (v) => {
                    tools.setValue(!!v);
                } }, rest)), label && _jsx(FieldLabel, { htmlFor: id, children: label })] }));
}
const FieldRoot = withClassName('div', 'layer-components:flex layer-components:flex-row layer-components:gap-2');
const FieldLabel = withClassName('label', 'layer-components:inline-flex layer-components:flex-col layer-components:gap-1 layer-components:text-md layer-components:font-normal layer-components:color-dark-blend layer-components:mt-2px');
//# sourceMappingURL=CheckboxField.js.map